
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that scrolls the page to the top when the route changes
 * Simplified for maximum reliability
 */
const useScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Force immediate scroll with no animation
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollToTop;
